export default "__VITE_ASSET__CWnbsh1s__"